import { render, staticRenderFns } from "./QuestionsManagement.vue?vue&type=template&id=7ffc4e02"
import script from "./QuestionsManagement.vue?vue&type=script&lang=js"
export * from "./QuestionsManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports